// Belongs to JobPosting Entity.
// Per Mudassir (May-20): the workflow is binary — a posting is either Open
// (hiring still in progress) or Filled (no further hiring actions allowed
// before onboarding; onboarding + post-hire actions remain enabled).
export const JobPostingStatusEnum = Object.freeze({
  Open: 0,
  Filled: 1,
});

export const JobPostingStatusLabel = Object.freeze({
  [JobPostingStatusEnum.Open]: "Open",
  [JobPostingStatusEnum.Filled]: "Filled",
});

//  Helper functions
export function getStatusKey(statusValue) {
  return Object.keys(JobPostingStatusEnum).find((key) => JobPostingStatusEnum[key] === statusValue);
}
